import './custom.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './custom.scss';
import Amplify from "aws-amplify";
import config from "./config";

Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: config.cognito.REGION,
        userPoolId: config.cognito.USER_POOL_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
        userPoolWebClientId: config.cognito.APP_CLIENT_ID
    },
    API: {
        endpoints: [
            {
                name: "soap",
                endpoint: config.apiGateway.URL,
                region: config.apiGateway.REGION
            },
            {
                name: "soaptwo",
                endpoint: " https://uxwrt6in5d.execute-api.us-east-1.amazonaws.com/dev",
                region: "us-east-1"
            },
            {
                name: "soapthree",
                endpoint: " https://mt3krk1q9c.execute-api.us-east-1.amazonaws.com/dev",
                region: "us-east-1"
            },
            {
                name: "return",
                endpoint: " https://d3vd813279.execute-api.us-east-1.amazonaws.com/test/",
                region: "us-east-1"
            },
        ]
    }
});


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
